window.VoterFly.tagHelpers = {
    intervalDate: function (wrapper) {

        const $wrapper = $(wrapper);
        const dateRole = (($wrapper.data('date-role') || 'start') + '').toLowerCase(); // 
        let mode = 'date-only';

        let dateComponents = {
            date: null,
            hour: null,
            minute: null,
            ampm: null,
            hasAnyValue: function () {
                if (mode === 'date-only') {
                    return !!this.date;
                }
                return !!(this.date || this.hour || this.minute || this.ampm);
            },
            hasAllValues: function () {
                if (mode === 'date-only') {
                    return !!this.date;
                }
                return !!(this.date && this.hour && this.minute && this.ampm);
            }
        };

        const $dateInput = $wrapper.find('input[type=date]');
        const $hourInput = $wrapper.find('select.hour');
        const $minuteInput = $wrapper.find('select.minute');
        const $amPmInput = $wrapper.find('select.ampm');
        const $clearLink = $wrapper.find('a.action-clear');
        const $addTimeLink = $wrapper.find('.action-add-time');
        const $removeTimeLink = $wrapper.find('.action-remove-time');
        const $hiddenInput = $wrapper.find('input[type=hidden]');

        setupElementValidation($dateInput);
        setupElementValidation($hourInput);
        setupElementValidation($minuteInput);
        setupElementValidation($amPmInput);

        function setupElementValidation($input) {
            $input.rules("add", {
                required: {
                    depends: function (element) {
                        // Time controls aren't required in date-only mode (they're hidden).
                        if (mode === 'date-only' && !$(element).is('input[type=date]')) {
                            return false;
                        }
                        return dateComponents.hasAnyValue();
                    }
                }
            });
        }

        function setMode(newMode) {
            mode = newMode;
            $wrapper.removeClass('mode-date-only mode-date-time').addClass('mode-' + newMode);
        }

        function formatDateForInput(d) {
            return d.getFullYear().toString() + '-' +
                (d.getMonth() + 1).toString().padStart(2, '0') + '-' +
                d.getDate().toString().padStart(2, '0');
        }

        function shiftDateString(dateString, days) {
            // dateString is YYYY-MM-DD; returns YYYY-MM-DD shifted by `days` (handles month/year rollover).
            const parts = dateString.split('-');
            const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
            d.setDate(d.getDate() + days);
            return formatDateForInput(d);
        }

        const rawValue = $hiddenInput.val();

        if (rawValue) {
            const date = new Date(rawValue);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();

            if (hours === 0 && minutes === 0 && seconds === 0) {
                // Stored as midnight => treat as date-only.
                let displayDate = formatDateForInput(date);
                if (dateRole === 'end') {
                    displayDate = shiftDateString(displayDate, -1);
                }
                dateComponents.date = displayDate;
                $dateInput.val(displayDate);
                setMode('date-only');
            } else {
                // Has a non-midnight time => date-time mode.
                dateComponents.date = formatDateForInput(date);
                if (hours >= 12) {
                    dateComponents.hour = (hours - 12).toString();
                    dateComponents.ampm = 'PM';
                } else {
                    dateComponents.hour = hours.toString();
                    dateComponents.ampm = 'AM';
                }
                dateComponents.minute = minutes.toString();
                $dateInput.val(dateComponents.date);
                $hourInput.val(dateComponents.hour);
                $minuteInput.val(dateComponents.minute);
                $amPmInput.val(dateComponents.ampm);
                setMode('date-time');
            }
            updateHiddenInput();
        }

        $clearLink.click(function () {
            dateComponents.date = null;
            dateComponents.hour = null;
            dateComponents.minute = null;
            dateComponents.ampm = null;
            $dateInput.val('');
            $hourInput.val('');
            $minuteInput.val('');
            $amPmInput.val('');
            setMode('date-only');
            updateHiddenInput();
        });

        $addTimeLink.click(function () {
            setMode('date-time');
            // Default to 12:00 PM (noon) if blank, so the form is in a valid state immediately.
            if (!dateComponents.hour) {
                dateComponents.hour = '0';
                $hourInput.val('0');
            }
            if (!dateComponents.minute) {
                dateComponents.minute = '0';
                $minuteInput.val('0');
            }
            if (!dateComponents.ampm) {
                dateComponents.ampm = 'PM';
                $amPmInput.val('PM');
            }
            updateHiddenInput();
        });

        $removeTimeLink.click(function () {
            dateComponents.hour = null;
            dateComponents.minute = null;
            dateComponents.ampm = null;
            $hourInput.val('');
            $minuteInput.val('');
            $amPmInput.val('');
            setMode('date-only');
            updateHiddenInput();
        });

        $dateInput.change(function () {
            dateComponents.date = $(this).val();
            updateHiddenInput();
        });

        $wrapper.find('select').change(function () {
            const $select = $(this);

            if ($select.hasClass('hour')) {
                dateComponents.hour = $select.val();
            } else if ($select.hasClass('minute')) {
                dateComponents.minute = $select.val();
            } else if ($select.hasClass('ampm')) {
                dateComponents.ampm = $select.val();
            }

            updateHiddenInput();
        });

        function updateHiddenInput() {
            if (mode === 'date-only') {
                if (!dateComponents.date) {
                    $hiddenInput.val('');
                    return;
                }
                let storedDateString = dateComponents.date;
                if (dateRole === 'end') {
                    storedDateString = shiftDateString(storedDateString, 1);
                }
                $hiddenInput.val(`${storedDateString}T00:00:00`);
                return;
            }

            // date-time mode
            if (!dateComponents.hasAllValues()) {
                $hiddenInput.val('');
                return;
            }

            let hour = parseInt(dateComponents.hour, 10);
            if (dateComponents.ampm === 'PM') {
                hour = hour + 12;
            }
            const hourString = hour.toString().padStart(2, '0');
            const minuteString = dateComponents.minute.toString().padStart(2, '0');

            $hiddenInput.val(`${dateComponents.date}T${hourString}:${minuteString}:00`);
        }
    }
};
